import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { AddActionEditActionButton } from 'components/shared/StyledComponents'
import i18n from 'common/util/internationalization'
import TemplateCard from './TemplateCard'

const useStyles = makeStyles(() => ({
    templateSelected: {
        padding: '0 24px 0 24px',
        marginTop: '16px',
        marginBottom: '24px'
    },
    templateTitle: {
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '20px',
        marginBottom: '8px',
        fontFamily: 'Source Sans Pro'
    },
    templateSubtitle: {
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '20px',
        color: '#676767',
        fontFamily: 'Source Sans Pro'
    },
    templateChangeButton: {
        borderRadius: 2,
        border: '1px solid #455D82'
    }
}))

interface SelectedTemplateCardProps {
    handleGetTemplatePreview: (id: string) => void
    templateOption: any
    templateOptions: any[]
    shouldShowTemplateList: boolean
}

const SelectedTemplateCard: React.FC<SelectedTemplateCardProps> = ({
    handleGetTemplatePreview,
    templateOption,
    templateOptions,
    shouldShowTemplateList
}) => {
    const classes = useStyles()

    let selectedTemplateOption = templateOption
    if (
        templateOption &&
        Object.keys(templateOption)?.length === 0 &&
        templateOptions &&
        templateOptions?.length > 0
    ) {
        selectedTemplateOption = templateOptions[0] // first template
    }
    if (!shouldShowTemplateList) {
        selectedTemplateOption = templateOptions[0]
    }

    return (
        <Box style={{ width: '100%' }}>
            <Box style={{ padding: '0 24px 0 24px' }}>
                <Typography className={classes.templateTitle}>
                    {i18n.t('MINUTES_TEMPLATES_TEMPLATE')}
                </Typography>
                <Typography className={classes.templateSubtitle}>
                    {shouldShowTemplateList
                        ? i18n.t('MINUTES_TEMPLATES_EXPORT_TEMPLATE_SUBTITLE_MINUTES')
                        : i18n.t('MINUTES_TEMPLATES_EXPORT_TEMPLATE_SUBTITLE_ACTIONS')}
                </Typography>
            </Box>
            <Box className={classes.templateSelected}>
                <TemplateCard
                    template={selectedTemplateOption}
                    onPreview={handleGetTemplatePreview}
                    showPreview={shouldShowTemplateList}
                    isActionsOnly={!shouldShowTemplateList}
                />
                {shouldShowTemplateList && (
                    <AddActionEditActionButton
                        className={classes.templateChangeButton}
                        key="changeTemplate"
                        disableFocusRipple
                        disableRipple
                        disabled={false}
                        tabIndex={0}
                        onClick={() => handleGetTemplatePreview(selectedTemplateOption.id)}
                        data-analytics="MM-Template-Change-Template">
                        {i18n.t('SELECTED_TEMPLATE_CARD_CHANGE_TEMPLATE')}
                    </AddActionEditActionButton>
                )}
            </Box>
        </Box>
    )
}

export default SelectedTemplateCard
